import { Box, Button, IconButton, Chip, Typography } from '@mui/material';
import { Search as SearchIcon, LibraryMusic, Close } from '@mui/icons-material';
import SearchBar from './SearchBar';
import SearchResults from './SearchResults';

export default function GlobalSearch({
  query,
  isExpanded,
  loading,
  error,
  results,
  hasActiveSearch,
  onToggle,
  onQueryChange,
  onClear,
  onClose
}) {
  return (
    <Box>
      {/* Search Header with Scope */}
      <Box
        sx={{
          mb: 2,
          display: 'flex',
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: 1.5,
          flexWrap: 'wrap'
        }}
      >
        <Typography
          variant="h5"
          component="h2"
          sx={{ fontWeight: 600, fontSize: { xs: '1.35rem', sm: '1.5rem' } }}
        >
          Search Episodes
        </Typography>
        <Chip
          icon={<LibraryMusic fontSize="small" />}
          label="All episodes"
          size="small"
          variant="outlined"
          color="primary"
          sx={{ fontWeight: 500 }}
        />
      </Box>

      {/* Mobile: Search icon that expands */}
      <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
        {!isExpanded ? (
          <Button
            onClick={onToggle}
            variant="outlined"
            color="primary"
            startIcon={<SearchIcon />}
            fullWidth
            sx={{ justifyContent: 'flex-start' }}
          >
            Search episodes
          </Button>
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              width: '100%',
              '& > .MuiTextField-root': {
                flex: 1,
                minWidth: 0
              }
            }}
          >
            <SearchBar
              value={query}
              onChange={onQueryChange}
              onClear={onClear}
              placeholder="Search episodes, summaries, and transcripts..."
            />
            <IconButton onClick={onClose} color="primary" aria-label="Close episode search">
              <Close />
            </IconButton>
          </Box>
        )}
      </Box>

      {/* Desktop: Always visible search bar */}
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <SearchBar
          value={query}
          onChange={onQueryChange}
          onClear={onClear}
          placeholder="Search episodes, summaries, and transcripts..."
        />
      </Box>

      {/* Hint Text */}
      {!hasActiveSearch && !loading && !error && (
        <Typography
          variant="caption"
          color="text.disabled"
          sx={{ display: 'block', mt: 1, maxWidth: 600 }}
        >
          Type at least 2 characters to search across all episode titles, summaries, and transcripts
        </Typography>
      )}

      {hasActiveSearch && loading && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Loading search…
        </Typography>
      )}

      {hasActiveSearch && error && (
        <Typography variant="body2" color="error.main" sx={{ mt: 2 }}>
          Search is unavailable right now. Please try again later.
        </Typography>
      )}

      {/* Search Results */}
      {hasActiveSearch && !loading && !error && (
        <Box sx={{ mt: 4 }}>
          <SearchResults results={results} query={query} />
        </Box>
      )}
    </Box>
  );
}
